export default __webpack_public_path__ + "static/media/added-favourite.bd009510.svg";